import axios from 'axios'
import { host } from '../../configuraciones'
import { v4 as uuidv4 } from 'uuid';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import moment from 'moment'

var fechaHoy = moment().format('YYYY-MM-DD');

//data inicial
const dataInicial = {
    data: {},
    fc_31: {
        fechasolicitud: fechaHoy,
        numerocliente: '',
        fechapropuesta: fechaHoy,
        tipoinstalacion: '',
        responsableinstalacion: '',
        correoelectronico: '',
        telefono: '',
        domicilio: '',
        ajustedegrado: false,
        mezcla: false,
        muestreo: false,
        ingresomaduracion: false,
        liberacionmaduracion: false,
    },
    loading: false,
    anexoMuestreo: [],
    anexoIngreso: [],
    anexoLiberacion: [],
    anexoAjusteGrado: [],
    anexoMezclaMuestreo: [],
    anexoIngreso: [],
    fc_31Map: {},
    anexoAjusteGradoMap: [],
    anexoMezclaMuestreoMap: [],
    anexoIngresoMap: [],
    paginaActiva: 1,
    modoEdicionBorrador: false,
    modoCorreccion: false,
    cliente: [],
    instalacionesCliente: [],
    dataLogin: [],
    dataDocumentacion: [],
    filesMuestreo: [],
    filesIngreso: [],
    anexosMuestreoMap: [],
    anexosIngresoMap: [],
    anexosLiberacionMap: [],
    filesMuestreoMap: [],
    filesIngresoMap: []
}

//types
const OBTENER_FC_31_DETALLE_EXITO = 'OBTENER_FC_31_DETALLE_EXITO'
const OBTENER_FC_31_MAP_EXITO_BENEFICIARIO = 'OBTENER_FC_31_MAP_EXITO_BENEFICIARIO'
const FC_31_SOLICITUD_EXITO = 'FC_31_SOLICITUD_EXITO'
const AGREGAR_FC_31_BORRADOR_EXITO = 'AGREGAR_FC_31_BORRADOR_EXITO'
const FC_31_ANEXO_AJUSTE_GRADO_SOLICITUD_EXITO = 'FC_31_ANEXO_AJUSTE_GRADO_SOLICITUD_EXITO'
const FC_31_ANEXO_MUESTRA_Y_MUESTREO_SOLICITUD_EXITO = 'FC_31_ANEXO_MUESTRA_Y_MUESTREO_SOLICITUD_EXITO'
const FC_31_ANEXO_INGRESO_SOLICITUD_EXITO = 'FC_31_ANEXO_INGRESO_SOLICITUD_EXITO'
const ACTUALIZAR_FC_31_ESTATUS_EXITO = 'ACTUALIZAR_FC_31_ESTATUS_EXITO'
const ELIMINAR_FC_31_SOLICITUD_EXITO_BD = 'ELIMINAR_FC_31_SOLICITUD_EXITO_BD'
const ELIMINAR_FC_31_ANEXOAJUSTE_EXITO_BD = 'ELIMINAR_FC_31_ANEXOAJUSTE_EXITO_BD'
const ELIMINAR_FC_31_ANEXOMEZCLA_EXITO_BD = 'ELIMINAR_FC_31_ANEXOMEZCLA_EXITO_BD'
const ELIMINAR_FC_31_ANEXOINGRESO_EXITO_BD = 'ELIMINAR_FC_31_ANEXOINGRESO_EXITO_BD'
const OBTENER_CLIENTE_POR_LOGIN_EXITO_31 = 'OBTENER_CLIENTE_POR_LOGIN_EXITO_31'
const OBTENER_FC_31_CONTADOR_FECHA_FOLIO_EXITO = 'OBTENER_FC_31_CONTADOR_FECHA_FOLIO_EXITO'
const ACTUALIZAR_FC_31_SOLICITUD_EXITO = 'ACTUALIZAR_FC_31_SOLICITUD_EXITO'
const AGREGAR_ARCHIVO_FC_31_EXITO = 'AGREGAR_ARCHIVO_FC_31_EXITO'
const ACTUALIZAR_ARCHIVO_FC_31_EXITO = 'ACTUALIZAR_ARCHIVO_FC_31_EXITO'

export const ObtenerClientePorLogin31 = createAsyncThunk(
    OBTENER_CLIENTE_POR_LOGIN_EXITO_31,
    async (params) => {
        try {
            const fullUrl = host + `InformacionValida/obtenerClientePorLogin/${params.idlogin}`

            const res = await axios.get(fullUrl)
            let idcliente = res.data.data.idcliente
            let idcartera = res.data.data.idcartera
            const fullUrlInstalaciones = host + `InformacionValida/obtenerTodosAnexosCliente/${idcliente}`
            const fullUrlDatosLogin = host + `AnexoUsuario/obtenerDatosLoginPorCartera/${idcartera}`
            /*const fullUrlAnexos = host + `FC_01/obtenerSeccionesDeAnexo/${3}`
            const resAnexos = await axios.get(fullUrlAnexos)

            console.log("los datos de secciones es ", resAnexos.data.data)*/

            const resinstalaciones = await axios.get(fullUrlInstalaciones)
            for (const i in resinstalaciones.data.data) {
                let { ...anexo } = resinstalaciones.data.data[i]
                if (resinstalaciones.data.data[i].idtipoanexo == 3) {
                    let graneles = false
                    let productoTerminado = false
                    let maduracion = false
                    for (const b in resinstalaciones.data.data[i].dataelementocliente) {
                        if (resinstalaciones.data.data[i].dataelementocliente[b].idseccion == 11) productoTerminado = true
                        if (resinstalaciones.data.data[i].dataelementocliente[b].idseccion == 5) graneles = true
                        if (resinstalaciones.data.data[i].dataelementocliente[b].idseccion == 12) maduracion = true
                    }
                    let secciones = ''
                    if (productoTerminado) secciones += 'Producto terminado'
                    if (productoTerminado && (graneles || productoTerminado)) secciones += ', '
                    if (graneles) secciones += 'Graneles'
                    if ((productoTerminado || graneles)&& maduracion) secciones += ', '
                    if (maduracion) secciones += 'Maduración de productos'
                    resinstalaciones.data.data[i].secciones = secciones
                }
            }

            console.log("los datos de resinstalaciones es ", resinstalaciones.data.data)
            let datos = []
            let instalaciones = []
            instalaciones.push(resinstalaciones.data.data)
            const resdatoslogin = await axios.get(fullUrlDatosLogin)
            let datosLogin = []
            datosLogin.push(resdatoslogin.data.data)
            datos.push(res.data.data, instalaciones, datosLogin)
            return datos
        } catch (error) {
            console.log(error);
        }
    }
)

export const obtenerContadorDeFechaFolio = createAsyncThunk(
    OBTENER_FC_31_CONTADOR_FECHA_FOLIO_EXITO,
    async (year) => {
        try {
            const fullUrl = host + `Estatus/ContadorGeneralDeFechasFolio/year=${year}`
            const res = await axios.get(fullUrl)
            const contador =
                res.data.data.resultfc_01[0].count + res.data.data.resultfc_05[0].count + res.data.data.resultfc_06[0].count +
                res.data.data.resultfc_08[0].count + res.data.data.resultfc_09[0].count + res.data.data.resultfc_30[0].count +
                res.data.data.resultfc_31[0].count + res.data.data.resultfc_33[0].count + res.data.data.resultfc_34[0].count +
                res.data.data.resultfc_35[0].count + res.data.data.resultfc_36[0].count + res.data.data.resultfc_40[0].count +
                res.data.data.resultfc_41[0].count
            return contador
        } catch (error) {
            console.log(error)
        }
    }
)
export const registrarSolicitudFC_31Accion = createAsyncThunk(
    FC_31_SOLICITUD_EXITO,
    async (data) => {
        try {
            const solicitud = { data: data.solicitud }
            const muestreo = data.muestreo
            const ingreso = data.ingreso
            const liberacion = data.liberacion

            const agregarFC = host + 'FC_31/agregarFormatoFC31'
            const urlAnexoMuestreo = host + 'FC_31/agregarFormatoFC31_AnexoMuestreo'
            const urlAnexoIngreso = host + 'FC_31/agregarFormatoFC31_AnexoIngreso'
            const urlAnexoLiberacion = host + 'FC_31/agregarFormatoFC31_AnexoLiberacion'

            const res = await axios.post(agregarFC, solicitud)
            let idfc31_solicitudseguimiento = res.data.data.idfc31_solicitudseguimiento

            for (let i in muestreo) {
                const { id, ...anexo } = muestreo[i]
                anexo.idfc31_solicitudseguimiento = idfc31_solicitudseguimiento
                if (anexo.mezcla === '✔') anexo.mezcla = true
                else anexo.mezcla = false
                if (anexo.ajuste === '✔') anexo.ajuste = true
                else anexo.ajuste = false
                await axios.post(urlAnexoMuestreo, { data: anexo })
            }
            for (let i in ingreso) {
                const { id, ...anexo } = ingreso[i]
                anexo.idfc31_solicitudseguimiento = idfc31_solicitudseguimiento
                anexo.fechaingreso = new Date(anexo.fechaingreso).toISOString()
                await axios.post(urlAnexoIngreso, { data: anexo })
            }
            for (let i in liberacion) {
                const { id, ...anexo } = liberacion[i]
                anexo.idfc31_solicitudseguimiento = idfc31_solicitudseguimiento
                await axios.post(urlAnexoLiberacion, { data: anexo })
            }

            return { data: res.data.data }
        } catch (error) {
            console.log(error)
        }
    }
)

export const obtenerFC_31SolicitudDetalle = createAsyncThunk(
    OBTENER_FC_31_DETALLE_EXITO,
    async (idSolicitud) => {
        try {
            const fullUrl = host + `FC_31/obtenerFormatoFC31_ConDetalle/${idSolicitud}`
            const res = await axios.get(fullUrl)
            let anexoMuestreo = []
            let anexoIngreso = []
            let anexoLiberacion = []

            let filesMuestreo = []
            for (let i in res.data.data.fc_31_anexomuestreo) {
                res.data.data.fc_31_anexomuestreo[i]['id'] = uuidv4()
                if (res.data.data.fc_31_anexomuestreo[i].ajuste === true) res.data.data.fc_31_anexomuestreo[i].ajuste = '✔'
                else res.data.data.fc_31_anexomuestreo[i].ajuste = ''
                if (res.data.data.fc_31_anexomuestreo[i].mezcla === true) res.data.data.fc_31_anexomuestreo[i].mezcla = '✔'
                else res.data.data.fc_31_anexomuestreo[i].mezcla = ''
                anexoMuestreo.push(res.data.data.fc_31_anexomuestreo[i])

                for (const j in res.data.data.fc_31_anexomuestreo[i].fc_31archivomuestreo) {
                    const { ...anexo } = res.data.data.fc_31_anexomuestreo[i].fc_31archivomuestreo[j]
                    const data = {
                        id: anexo.nameid,
                        file: { name: await getNameFile(anexo.ruta) },
                        idAnexo: anexo.idfc_31archivomuestreo,
                        idAnexoFK: res.data.data.fc_31_anexomuestreo[i].idfc31_anexomuestreo,
                        estatus: true,
                    }
                    filesMuestreo.push(data)
                }
            }
            let filesIngreso = []
            for (let i in res.data.data.fc_31_anexoingresomaduracion) {
                res.data.data.fc_31_anexoingresomaduracion[i]['id'] = uuidv4()
                res.data.data.fc_31_anexoingresomaduracion[i].fechaingreso = moment(res.data.data.fc_31_anexoingresomaduracion[i].fechaingreso).format('YYYY-MM-DD')
                anexoIngreso.push(res.data.data.fc_31_anexoingresomaduracion[i])

                for (const j in res.data.data.fc_31_anexoingresomaduracion[i].fc_31archivoingreso) {
                    const { ...anexo } = res.data.data.fc_31_anexoingresomaduracion[i].fc_31archivoingreso[j]
                    const data = {
                        id: anexo.nameid,
                        file: { name: await getNameFile(anexo.ruta) },
                        idAnexo: anexo.idfc_31archivoingreso,
                        idAnexoFK: res.data.data.fc_31_anexoingresomaduracion[i].idfc31_anexoingresomaduracion,
                        estatus: true,
                    }
                    filesIngreso.push(data)
                }
            }
            //anexoIngreso = res.data.data.fc_31_anexoingresomaduracion

            for (let i in res.data.data.fc_31_anexoliberacionmaduracion) {
                res.data.data.fc_31_anexoliberacionmaduracion[i]['id'] = uuidv4()
                anexoLiberacion.push(res.data.data.fc_31_anexoliberacionmaduracion[i])
            }
            //anexoLiberacion = res.data.data.fc_31_anexoliberacionmaduracion
            if (res.data.data.fechapropuesta) {
                let fecha = res.data.data.fechapropuesta
                res.data.data.fechapropuesta = moment(fecha).add(1, 'd').format('YYYY-MM-DD')
            }
            let solicitud = {
                data: res.data.data,
                anexoMuestreo,
                anexoIngreso,
                anexoLiberacion,
                filesMuestreo,
                filesIngreso
            }
            return solicitud
        } catch (error) {
            console.log(error);
        }
    }
)
const getNameFile = async (ruta) => {
    let nameFile = null
    const array = ruta.split("/")
    // const array = ruta.split("\\")//local
    nameFile = array[array.length - 1]
    return nameFile
}
export const eliminarFC_31SolicitudBD = createAsyncThunk(
    ELIMINAR_FC_31_SOLICITUD_EXITO_BD,
    async (id) => {
        try {
            const fullUrlSolicitud = host + `FC_31/eliminarFormatoFC31/${id}`
            const resultDelete = await axios.delete(fullUrlSolicitud)
            return { id }
        } catch (error) {
            console.log(error);
        }
    }
)

export const eliminarFC_31AnexoMuestreoBD = createAsyncThunk(
    ELIMINAR_FC_31_ANEXOAJUSTE_EXITO_BD,
    async (id) => {
        try {
            const fullUrl = host + `FC_31/eliminarFormatoFC31_AnexoMuestreo/${id}`
            await axios.delete(fullUrl)
            return id
        } catch (error) {
            console.log(error);
        }
    }
)
export const eliminarFC_31AnexoIngresoBD = createAsyncThunk(
    ELIMINAR_FC_31_ANEXOMEZCLA_EXITO_BD,
    async (id) => {
        try {
            const fullUrl = host + `FC_31/eliminarFormatoFC31_AnexoIngreso/${id}`
            await axios.delete(fullUrl)
            return id
        } catch (error) {
            console.log(error);
        }
    }
)
export const eliminarFC_31AnexoLiberacionBD = createAsyncThunk(
    ELIMINAR_FC_31_ANEXOINGRESO_EXITO_BD,
    async (id) => {
        try {
            const fullUrl = host + `FC_31/eliminarFormatoFC31_AnexoLiberacion/${id}`
            await axios.delete(fullUrl)
            return id
        } catch (error) {
            console.log(error);
        }
    }
)
export const actualizarFC_31Solicitud = createAsyncThunk(
    ACTUALIZAR_FC_31_SOLICITUD_EXITO,
    async (data) => {
        try {
            const solicitud = { data: data.solicitud }
            const muestreo = data.muestreo
            const ingreso = data.ingreso
            const liberacion = data.liberacion
            console.log("data ", data)
            const actulizarFC = host + 'FC_31/actualizarFormatoFC31'
            const urlAnexoMuestreo = host + 'FC_31/agregarFormatoFC31_AnexoMuestreo'
            const urlAnexoIngreso = host + 'FC_31/agregarFormatoFC31_AnexoIngreso'
            const urlAnexoLiberacion = host + 'FC_31/agregarFormatoFC31_AnexoLiberacion'

            const urlActualizarAnexoMuestreo = host + 'FC_31/actualizarFormatoFC31_AnexoMuestreo'
            const urlActualizarAnexoIngreso = host + 'FC_31/actualizarFormatoFC31_AnexoIngreso'
            const urlActualizarAnexoLiberacion = host + 'FC_31/actualizarFormatoFC31_AnexoLiberacion'

            const res = await axios.put(actulizarFC, solicitud)
            console.log("res ", res)
            let idfc31_solicitudseguimiento = res.data.data.idfc31_solicitudseguimiento

            for (let i in muestreo) {
                const { id, fc_31archivomuestreo, ...anexo } = muestreo[i]
                if (anexo.mezcla == '✔') anexo.mezcla = true
                else anexo.mezcla = false
                if (anexo.ajuste == '✔') anexo.ajuste = true
                else anexo.ajuste = false

                if (anexo.idfc31_anexomuestreo) {
                    console.log("entro en actualizar " )
                    await axios.put(urlActualizarAnexoMuestreo, { data: anexo })
                } else {
                    anexo.idfc31_solicitudseguimiento = idfc31_solicitudseguimiento
                    await axios.post(urlAnexoMuestreo, { data: anexo })
                }
            }

            for (let i in ingreso) {
                const { id, fc_31archivoingreso, ...anexo } = ingreso[i]
                anexo.fechaingreso = new Date(anexo.fechaingreso).toISOString()
                if (anexo.idfc31_anexoingresomaduracion) {
                    await axios.put(urlActualizarAnexoIngreso, { data: anexo })
                } else {
                    anexo.idfc31_solicitudseguimiento = idfc31_solicitudseguimiento
                    await axios.post(urlAnexoIngreso, { data: anexo })
                }
            }

            for (let i in liberacion) {
                const { id, ...anexo } = liberacion[i]
                if (anexo.idfc31_anexoliberacionmaduracion) {
                    await axios.put(urlActualizarAnexoLiberacion, { data: anexo })
                } else {
                    anexo.idfc31_solicitudseguimiento = idfc31_solicitudseguimiento
                    await axios.post(urlAnexoLiberacion, { data: anexo })
                }
            }
            return { data: res.data.data }
        } catch (error) {
            console.log(error)
        }
    }
)
export const agregarFileFC_31 = createAsyncThunk(
    AGREGAR_ARCHIVO_FC_31_EXITO,
    async (data) => {
        try {
            const { archivo, ruta } = data
            const result = await agregarFile(archivo, ruta)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)
const agregarFile = async (data, url) => {
    let formData = new FormData();
    formData.append(1, data.file)
    formData.append('nameId', data.id)
    formData.append('idSolicitud', data.idAnexoFK)
    const resFile = await axios.post(host + url, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
    return resFile
}
export const actualizarFileFC_31 = createAsyncThunk(
    ACTUALIZAR_ARCHIVO_FC_31_EXITO,
    async (data) => {
        try {
            const { archivo, ruta } = data
            const result = await actualizarFile(archivo, ruta)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)
const actualizarFile = async (data, url) => {
    let formData = new FormData();
    formData.append(1, data.file)
    formData.append('nameId', data.id)
    formData.append('idSolicitud', data.idAnexo)
    formData.append('idSolicitudFK', data.idAnexoFK)
    const resFile = await axios.put(host + url, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
    return resFile
}
export const actualizarFC_31Estatus = createAsyncThunk(
    ACTUALIZAR_FC_31_ESTATUS_EXITO,
    async (data) => {
        try {
            const fullUrl = host + 'Estatus/actualizarEstatusTablas'
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)
export const obtenerFC_31Map = createAsyncThunk(
    OBTENER_FC_31_MAP_EXITO_BENEFICIARIO,
    async (solicitudId) => {
        try {
            const fullUrl = host + `MapSolicitud/obtenerMapFC_31_Solicitud/${solicitudId}`
            const res = await axios.get(fullUrl)

            const anexosMap = await obtenerAnexosMap(solicitudId)

            const solicitudMap = {
                data: res.data.data,
                anexoMustreoMap: anexosMap.anexoMuestreoMap,
                anexoIngresoMap: anexosMap.anexoIngresoMap,
                anexoLiberacionMap: anexosMap.anexoLiberacionMap,
                archivoMuestreoMap: anexosMap.archivoMuestreoMap,
                archivoIngresoMap: anexosMap.archivoIngresoMap,
            }
            return solicitudMap
        } catch (error) {
            console.log(error)
        }
    }
)

const obtenerAnexosMap = async (idSolicitud) => {

    try {
        const fullUrl = host + `FC_31/obtenerFormatoFC31_ConDetalle/${idSolicitud}`

        const obtenerMuestreoMap = host + `MapSolicitud/obtenerMapFC_31_Muestreo/`
        const obtenerIngresoMap = host + `MapSolicitud/obtenerMapFC_31_AnexoIngreso/`
        const obtenerLiberacionMap = host + `MapSolicitud/obtenerMapFC_31_AnexoLiberacion/`
        const obtenerArchivosMuestreoMap = host + `MapSolicitud/obtenerMapFC_31_ArchivosMuestreo/`
        const obtenerArchivosIngresoMap = host + `MapSolicitud/obtenerMapFC_31_ArchivosIngreso/`

        const res = await axios.get(fullUrl)
        let muestreo = res.data.data.fc_31_anexomuestreo
        let ingreso = res.data.data.fc_31_anexoingresomaduracion
        let liberacion = res.data.data.fc_31_anexoliberacionmaduracion

        let anexoMuestreoMap = []
        let anexoIngresoMap = []
        let anexoLiberacionMap = []
        let archivoMuestreoMap = []
        let archivoIngresoMap = []

        for (const i in muestreo) {
            const resMap = await axios.get(obtenerMuestreoMap + muestreo[i].idfc31_anexomuestreo)
            anexoMuestreoMap.push(resMap.data.data)
            for (const j in muestreo[i].fc_31archivomuestreo) {
                const resfiles = await axios.get(obtenerArchivosMuestreoMap + muestreo[i].fc_31archivomuestreo[j].idfc_31archivomuestreo)
                if (resfiles.data.data) {
                    resfiles.data.data.idAnexoBD = resfiles.data.data.idfc_31archivomuestreo
                    archivoMuestreoMap.push(resfiles.data.data)
                }
            }
        }
        for (const i in ingreso) {
            const resMap = await axios.get(obtenerIngresoMap + ingreso[i].idfc31_anexoingresomaduracion)
            anexoIngresoMap.push(resMap.data.data)
            for (const j in ingreso[i].fc_31archivoingreso) {
                const resfiles = await axios.get(obtenerArchivosIngresoMap + ingreso[i].fc_31archivoingreso[j].idfc_31archivoingreso)
                if (resfiles.data.data) {
                    resfiles.data.data.idAnexoBD = resfiles.data.data.idfc_31archivoingreso
                    archivoIngresoMap.push(resfiles.data.data)
                }
            }
        }
        for (const i in liberacion) {
            const resMap = await axios.get(obtenerLiberacionMap + liberacion[i].idfc31_anexoliberacionmaduracion)
            anexoLiberacionMap.push(resMap.data.data)
        }


        let anexosMap = {
            anexoMuestreoMap,
            anexoIngresoMap,
            anexoLiberacionMap,
            archivoMuestreoMap,
            archivoIngresoMap
        }
        return anexosMap
    } catch (error) {
        console.log(error);
    }
}

































export const agregarFC_31SolicitudBorrador = createAsyncThunk(
    AGREGAR_FC_31_BORRADOR_EXITO,
    async (data) => {
        try {
            const solicitud = { data: data.solicitud }
            const ajustesGradoAGuardar = { data: data.ajustesGradoAGuardar }
            const muestreosAGuardar = { data: data.muestreosAGuardar }
            const ingresosAGuardar = { data: data.ingresosAGuardar }


            const agregarFC_31 = host + 'FC_31/agregarFormatoFC31'
            const urlAnexoAjusteDeGrado = host + 'FC_31/agregarFormatoFC31AnexoAjusteDeGrado'
            const urlAnexoMuestraYMuestreo = host + 'FC_31/agregarFormatoFC31AnexoMuestraYMuestreo'
            const urlAnexoIngreso = host + 'FC_31/agregarFormatoFC31AnexoIngreso'
            const res = await axios.post(agregarFC_31, solicitud)

            let idfc31_solicitudseguimiento = res.data.data.idfc31_solicitudseguimiento

            for (const anexo of ajustesGradoAGuardar.data) {
                anexo.idfc31_solicitudseguimiento = idfc31_solicitudseguimiento
                await axios.post(urlAnexoAjusteDeGrado, { data: anexo })
            }
            for (const anexo of muestreosAGuardar.data) {
                anexo.idfc31_solicitudseguimiento = idfc31_solicitudseguimiento
                await axios.post(urlAnexoMuestraYMuestreo, { data: anexo })
            }
            for (const anexo of ingresosAGuardar.data) {
                anexo.idfc31_solicitudseguimiento = idfc31_solicitudseguimiento
                if (anexo.fechaingresomaduracion === "") anexo.fechaingresomaduracion = null
                if (anexo.numerolotemaduracion === "") anexo.numerolotemaduracion = null
                if (anexo.numerorecipientes === "") anexo.numerorecipientes = null
                if (anexo.capacidad === "") anexo.capacidad = null

                await axios.post(urlAnexoIngreso, { data: anexo })
            }
            return {
                solicitud,
                ajustesGradoAGuardar,
                muestreosAGuardar,
                ingresosAGuardar
            }
        } catch (error) {
            console.log(error)
        }
    }
)
export const actualizarFC_31SolicitudBorrador = createAsyncThunk(
    AGREGAR_FC_31_BORRADOR_EXITO,
    async (data) => {
        try {
            const solicitud = { data: data.solicitud }

            /*Anexo ajustes de grado*/
            const ajustesGradoAGuardar = { data: data.ajustesGradoAGuardar }
            const ajustesGradoParaActualizar = { data: data.ajustesGradoParaActualizar }
            const ajustesDeGradoAEliminar = data.ajustesDeGradoAEliminar

            /*Anexo mezclas y muestreo*/
            const muestreosAGuardar = { data: data.muestreosAGuardar }
            const muestreosParaActualizar = { data: data.muestreosParaActualizar }
            const mezclasYMuestreosAEliminar = data.mezclasYMuestreosAEliminar

            /*Anexo Ingresos*/
            const ingresosAGuardar = { data: data.ingresosAGuardar }
            const ingresosParaActualizar = { data: data.ingresosParaActualizar }
            const ingresosAEliminar = data.ingresosAEliminar


            const actualizarFC_31 = host + 'FC_31/actualizarFormatoFC31'

            const urlAgregarAnexoAjusteDeGrado = host + 'FC_31/agregarFormatoFC31AnexoAjusteDeGrado'
            const urlActualizarAnexoAjusteDeGrado = host + 'FC_31/actualizarFormatoFC31AnexoAjusteDeGrado'
            const urlEliminarAnexoAjusteDeGrado = host + 'FC_31/eliminarFormatoFC31AnexoAjusteDeGrado/'

            const urlAgregarAnexoMuestraYMuestreo = host + 'FC_31/agregarFormatoFC31AnexoMuestraYMuestreo'
            const urlActualizarAnexoMuestraYMuestreo = host + 'FC_31/actualizarFormatoFC31AnexoMuestraYMuestreo'
            const urlEliminarAnexoMuestraYMuestreo = host + 'FC_31/eliminarFormatoFC31AnexoMuestraYMuestreo/'

            const urlAgregarAnexoIngreso = host + 'FC_31/agregarFormatoFC31AnexoIngreso'
            const urlActualizarAnexoIngreso = host + 'FC_31/actualizarFormatoFC31AnexoIngreso'
            const urlEliminarAnexoIngreso = host + 'FC_31/eliminarFormatoFC31AnexoIngreso/'

            const res = await axios.put(actualizarFC_31, solicitud)
            let idfc31_solicitudseguimiento = solicitud.data.idfc31_solicitudseguimiento

            /*Acciones para anexo Ajuste de grado*/
            for (const anexo of ajustesGradoAGuardar.data) {
                anexo.idfc31_solicitudseguimiento = idfc31_solicitudseguimiento
                const resAnexo = await axios.post(urlAgregarAnexoAjusteDeGrado, { data: anexo })
            }
            for (const anexo of ajustesGradoParaActualizar.data) {
                anexo.contenidoalcoholico = Number(anexo.contenidoalcoholico)
                const resAnexo = await axios.put(urlActualizarAnexoAjusteDeGrado, { data: anexo })
            }
            for (const anexo of ajustesDeGradoAEliminar) {
                const resAnexo = await axios.delete(urlEliminarAnexoAjusteDeGrado + anexo.datoEliminado.idfc31_anexoajustegrado)
            }

            /*Acciones para anexo mezcla y muestreo*/
            for (const anexo of muestreosAGuardar.data) {
                anexo.idfc31_solicitudseguimiento = idfc31_solicitudseguimiento

                const resAnexo = await axios.post(urlAgregarAnexoMuestraYMuestreo, { data: anexo })
            }
            for (const anexo of muestreosParaActualizar.data) {
                const resAnexo = await axios.put(urlActualizarAnexoMuestraYMuestreo, { data: anexo })
            }
            for (const anexo of mezclasYMuestreosAEliminar) {
                const resAnexo = await axios.delete(urlEliminarAnexoMuestraYMuestreo + anexo.datoEliminado.idfc31_anexomuestraymuestreo)
            }
            /*Acciones para anexo ingresos*/
            for (const anexo of ingresosAGuardar.data) {
                anexo.idfc31_solicitudseguimiento = idfc31_solicitudseguimiento
                if (anexo.fechaingresomaduracion === "") anexo.fechaingresomaduracion = null
                if (anexo.numerolotemaduracion === "") anexo.numerolotemaduracion = null
                if (anexo.numerorecipientes === "") anexo.numerorecipientes = null
                if (anexo.capacidad === "") anexo.capacidad = null
                const resAnexo = await axios.post(urlAgregarAnexoIngreso, { data: anexo })
            }
            for (const anexo of ingresosParaActualizar.data) {
                if (anexo.fechaingresomaduracion === "") anexo.fechaingresomaduracion = null
                if (anexo.numerolotemaduracion === "") anexo.numerolotemaduracion = null
                if (anexo.numerorecipientes === "") anexo.numerorecipientes = null
                if (anexo.capacidad === "") anexo.capacidad = null
                const resAnexo = await axios.put(urlActualizarAnexoIngreso, { data: anexo })
            }
            for (const anexo of ingresosAEliminar) {
                const resAnexo = await axios.delete(urlEliminarAnexoIngreso + anexo.datoEliminado.idfc31_anexoingreso)
            }
            return data
        } catch (error) {
            console.log(error)
        }
    }
)




export const fc31Slice = createSlice({
    name: 'fc31Slice',
    initialState: dataInicial,
    reducers: {
        guardarCambiosFC_31SolicitudBorrador(state, { payload }) {
            state.data = payload
        },
        guardarCambiosFC_31SolicitudNueva(state, { payload }) {
            state.fc_31 = payload
        },

        actualizarModoBorradorFC_31(state, { payload }) {
            state.modoEdicionBorrador = payload
        },
        actualizarModoCorrecionFC_31(state, { payload }) {
            state.modoCorreccion = payload
        },
        actualizarFC_31PaginaActiva(state, { payload }) {
            state.paginaActiva = payload
        },
        editarFC_31AnexoAjuste(state, { payload }) {
            const input = state.anexoAjusteGrado.data.filter(field => field.id === payload.id)
            if (input.length > 0) {
                input[0][payload.campo] = payload.valor
            }
        },
        editarFC_31AnexoMuestra(state, { payload }) {
            const input = state.anexoMezclaMuestreo.data.filter(field => field.id === payload.id)
            if (input.length > 0) {
                input[0][payload.campo] = payload.valor
            }
        },
        editarFC_31AnexoIngreso(state, { payload }) {
            const input = state.anexoIngreso.data.filter(field => field.id === payload.id)
            if (input.length > 0) {
                input[0][payload.campo] = payload.valor
            }
        },
        resetDataFC_31(state, { payload }) {
            return dataInicial
        },
    },
    extraReducers: {
        [ObtenerClientePorLogin31.fulfilled]: (state, { payload }) => {
            state.cliente = payload[0]
            state.instalacionesCliente = payload[1][0]
            state.dataLogin = payload[2][0][0]
        },
        [obtenerFC_31SolicitudDetalle.fulfilled]: (state, { payload }) => {
            console.log("los datos de detalle es payload ", payload)
            state.data = payload.data
            state.fc_31 = payload.data
            state.dataDocumentacion = payload.data
            state.anexoMuestreo = payload.anexoMuestreo
            state.anexoIngreso = payload.anexoIngreso
            state.anexoLiberacion = payload.anexoLiberacion
            state.filesMuestreo = payload.filesMuestreo
            state.filesIngreso = payload.filesIngreso
        },
        [obtenerFC_31Map.fulfilled]: (state, { payload }) => {
            console.log("lo que llega al payload detalle map es ", payload)
            state.fc_31Map = payload.data
            state.anexosMuestreoMap = payload.anexoMustreoMap
            state.anexosIngresoMap = payload.anexoIngresoMap
            state.anexosLiberacionMap = payload.anexoLiberacionMap
            state.filesMuestreoMap = payload.archivoMuestreoMap
            state.filesIngresoMap = payload.archivoIngresoMap
        },
        [registrarSolicitudFC_31Accion.fulfilled]: (state, { payload }) => {
        },
        [actualizarFC_31SolicitudBorrador.fulfilled]: (state, { payload }) => {
        },
        [actualizarFC_31Estatus.fulfilled]: (state, { payload }) => {
        },
        [eliminarFC_31SolicitudBD.fulfilled]: (state, { payload }) => {
        },
    },
})

//actions
export const {
    guardarCambiosFC_31SolicitudBorrador,
    guardarCambiosFC_31SolicitudNueva,
    agregarFC_31AnexoAjuste,
    agregarFC_31Ajuste,
    agregarFC_31AnexoMuestra,
    agregarFC_31Muestra,
    agregarFC_31AnexoIngreso,
    agregarFC_31Ingreso,
    actualizarModoBorradorFC_31,
    actualizarModoCorrecionFC_31,
    actualizarFC_31PaginaActiva,
    editarFC_31AnexoAjuste,
    editarFC_31AnexoMuestra,
    editarFC_31AnexoIngreso,
    resetDataFC_31
} = fc31Slice.actions

export const FC31ReducerBeneficiario = fc31Slice.reducer
